import React, { useState, useEffect } from 'react'
import { List, Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import HTMLWidget from '../../HTMLWidget'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { saveFormProjectAttachments } from '../../../redux/actions/subProjectProposal'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { downloadSubprojectFile } from '../../../redux/actions/subProject'
import UploaderForm from '../../../components/forms/input/UploaderForm'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import { cloneDeep, forEach, isEmpty } from 'lodash-es'
import InputForm from '../../../components/forms/input/InputForm'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function ProposalAttachmentsWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [newObjects, setNewObjects] = useState([])
  const [newObjectsView, setNewObjectsView] = useState([])
  const [newObjectsValue, setNewObjectsValue] = useState(new Map())
  const [newIndex, setNewIndex] = useState(0)
  const [delIds, setDelIds] = useState([])
  const [isRefash, setIsRefash] = useState(false)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    setFormData(props.schema?.newObjects)
  }, [props.schema])

  // useEffect(() => {
  //   setFormData(formSchema?.newObjects)
  // }, [formSchema])

  const setFormData = (values) => {
    var datas = []
    var datasView = []
    var map = new Map()

    values?.forEach((item) => {
      var inputForm = cloneDeep(props.schema?.inputForm)

      inputForm.name.name += ':' + item.id
      inputForm.name.value = item.label

      inputForm.file.name += ':' + item.id
      inputForm.file.value = item.pathFile
      inputForm.file.label = item.label

      datas.push({ id: item.id, inputForm: inputForm })

      //datasView.push(inputForm.name)
      datasView.push(inputForm.file)

      map.set(item.id, { label: item.label, pathFile: item.pathFile })
    })

    setNewObjectsValue(map)
    setNewObjects(datas)
    setNewObjectsView({ objects: datasView })
  }

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectAttachments(subProjectId, request)
      // console.log(response)

      if (response) {
        setFormSchema(response)
        setFormData(response.newObjects)
        onClear(true)
        onRefash()
        setAlertMessage('success', SAVE_SUCCESS_MSG)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onPreview = async (path, name) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(path)

      previewFile(file, name)
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
  }

  const onDownload = async (path, name) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(path)

      downloadFile(file, name)
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const formData = new FormData()

    formData.append('Id', formSchema.id || null)

    let index = 0

    formSchema.objects?.forEach((item) => {
      var files = data[item.name] || []
      if (files?.length > 0) {
        formData.append(`Values[${index}].Id`, item.id || null)
        formData.append(`Values[${index}].RefId`, item.name || null)
        formData.append(`Values[${index}].File`, files[0]?.blobFile || null)

        index++
      }
    })

    newObjects?.forEach((item) => {
      //var files = data[`file:${item.name}`] || []
      //var label = data[`name:${item.name}`] || ''

      formData.append(`Values[${index}].Id`, item.id)

      var objValue = newObjectsValue.get(item.id)
      if (objValue?.file && objValue.file[0]?.blobFile) {
        formData.append(`Values[${index}].File`, objValue.file[0].blobFile)
      }

      formData.append(`Values[${index}].Label`, objValue.label)

      index++
    })

    delIds?.forEach((id) => {
      formData.append('DelIds', id)
    })

    handleSave(formData)
  }

  const setAlertMessage = (type, message) => {
    setNotiMsg({
      type: type,
      msg: message,
    })

    notification.open(type, {
      title: message,
      duration: 2500,
    })

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onAdd = () => {
    var inputForm = cloneDeep(props.schema?.inputForm)

    inputForm.name.name += ':NEW_' + newIndex
    inputForm.file.name += ':NEW_' + newIndex

    var datas = newObjects || []

    var newId = 'NEW_' + newIndex

    datas.push({ id: newId, inputForm: inputForm })
    setNewObjects(datas)

    var map = newObjectsValue
    map.set(newId, { label: '', filePath: '' })
    setNewObjectsValue(map)

    setNewIndex(newIndex + 1)
  }

  const onDelete = (item, index) => {
    if (!item.id.startsWith('NEW_')) {
      var ids = cloneDeep(delIds)
      ids.push(item.id)
      setDelIds(ids)
    }
    // console.log('onDelete item : ', item, ' , index : ', index)

    var newValue = cloneDeep(newObjectsValue)
    newValue.delete(item.id)
    // console.log('onDelete newValue : ', newValue)

    var obj = [...newObjects]
    obj.splice(index, 1)
    // console.log('onDelete obj : ', obj)
    setNewObjects([])
    setTimeout(() => {
      setNewObjects(obj)
    }, 50)
    setNewObjectsValue(newValue)
  }

  const onClear = (skip) => {
    setNewIndex(0)
    setDelIds([])

    if (!skip) {
      setFormData(formSchema?.newObjects)
    }
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* {formSchema.detail && <Row style={{ marginBottom: 20 }}>{formSchema.detail}</Row>} */}

      <HTMLWidget style={{ marginLeft: 20, marginBottom: 20 }} data={formSchema.detail} />

      {isEdit && showCommandButton ? (
        <>
          {!isRefash && (
            <>
              <EditFormWidget
                schema={formSchema}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                setLoading={setIsLoading}
              />

              <div style={{ marginTop: 20, marginLeft: 20 }}>
                <List bordered>
                  {newObjects?.map((item, index) => {
                    console.log('!isEmpty(item.inputForm.value) : ', item)

                    return (
                      <List.Item key={index} index={index}>
                        <InputForm
                          schema={item.inputForm.name}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          disabled={formSchema.disabled}
                          value={newObjectsValue.get(item.id)?.label}
                          onChange={(value) => {
                            var valueData = newObjectsValue.get(item.id)

                            console.log('valueData label ', valueData)

                            valueData['label'] = value

                            var object = newObjectsValue
                            object.set(item.id, valueData)

                            setNewObjectsValue(object)
                          }}
                        />
                        <UploaderForm
                          hideLabel
                          schema={item.inputForm.file}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          single={true}
                          ignoreValidate={!isEmpty(item.inputForm.file?.value)}
                          disabled={formSchema.disabled}
                          value={newObjectsValue.get(item.id)?.file}
                          onChange={(value) => {
                            var valueData = newObjectsValue.get(item.id)
                            valueData['file'] = value

                            var object = newObjectsValue
                            object.set(item.id, valueData)

                            setNewObjectsValue(object)
                          }}
                        />
                        {item.inputForm.file?.value && (
                          <div style={{ marginTop: 10 }}>
                            <ViewButton
                              style={{
                                marginRight: 10,
                                marginLeft: 10,
                                marginBottom: 10,
                              }}
                              // disabled={!subItem.value}
                              onClick={() => {
                                var fileNames = item.inputForm.file.value.split('/')
                                onPreview(item.inputForm.file.value, fileNames?.pop() || 'preview')
                              }}
                            />
                            <DownloadButton
                              //disabled={!subItem.value}
                              onClick={() => {
                                var fileNames = item.inputForm.file.value.split('/')
                                onDownload(
                                  item.inputForm.file.value,
                                  fileNames?.pop() || 'download'
                                )
                              }}
                            />
                          </div>
                        )}
                        <CancelButton
                          style={{ marginTop: 20 }}
                          disabled={isLoading}
                          onClick={() => {
                            onDelete(item, index)
                          }}
                          children="ลบรายการ"
                        />
                      </List.Item>
                    )
                  })}
                </List>

                <SaveButton
                  style={{ marginTop: 20 }}
                  disabled={isLoading}
                  onClick={onAdd}
                  children="เพิ่มรายการ"
                />
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <ViewFormWidget schema={formSchema} />

          <ViewFormWidget schema={newObjectsView} />
        </>
      )}

      {formSchema.note && (
        <Message
          style={{ marginTop: 20 }}
          showIcon
          type="info"
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              onClear()
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
